import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden"
}
const _hoisted_2 = { class: "p-6 border-b border-gray-100" }
const _hoisted_3 = { class: "flex items-center justify-between mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_5 = { class: "flex-1 h-1 bg-gray-100 rounded-full overflow-hidden" }
const _hoisted_6 = { class: "text-xs text-gray-500 whitespace-nowrap" }
const _hoisted_7 = { class: "p-6 overflow-hidden" }
const _hoisted_8 = { class: "text-base font-medium text-mumble-text mb-6" }
const _hoisted_9 = { class: "space-y-3" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "text-sm text-gray-700" }
const _hoisted_12 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_13 = { class: "text-2xl font-bold text-mumble-accent mb-6" }
const _hoisted_14 = { class: "bg-gray-50 rounded-xl p-4 mb-6 text-left" }
const _hoisted_15 = { class: "text-xs text-gray-500 leading-relaxed" }
const _hoisted_16 = { class: "flex gap-3" }
const _hoisted_17 = {
  key: 0,
  class: "p-6 pt-0 flex justify-between"
}
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = true)),
          class: "px-4 py-2 bg-mumble-accent text-white text-sm font-semibold rounded-lg hover:bg-mumble-accent/90 transition-all duration-200 flex items-center gap-2 cursor-pointer shadow-md hover:shadow-lg animate-pulse-gentle"
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            })
          ], -1),
          _createElementVNode("span", null, "Aiutami a scegliere", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.isOpen = false), ["self"]))
            }, [
              _createVNode(_Transition, { name: "slide-up" }, {
                default: _withCtx(() => [
                  (_ctx.isOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-lg font-semibold text-mumble-text" }, "Scegli il piano giusto", -1)),
                            _createElementVNode("button", {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false)),
                              class: "text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
                            }, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("svg", {
                                class: "w-5 h-5",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M6 18L18 6M6 6l12 12"
                                })
                              ], -1)
                            ]))])
                          ]),
                          (!_ctx.showResult)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                  _createElementVNode("div", {
                                    class: "h-full bg-mumble-accent transition-all duration-500 ease-out",
                                    style: _normalizeStyle({ width: `${((_ctx.currentStep + 1) / _ctx.questions.length) * 100}%` })
                                  }, null, 4)
                                ]),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentStep + 1) + " / " + _toDisplayString(_ctx.questions.length), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          (!_ctx.showResult)
                            ? (_openBlock(), _createBlock(_TransitionGroup, {
                                key: 0,
                                name: "question",
                                tag: "div",
                                class: "relative"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, index) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                      key: question.id
                                    }, [
                                      _createElementVNode("p", _hoisted_8, _toDisplayString(question.text), 1),
                                      _createElementVNode("div", _hoisted_9, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (option, optIndex) => {
                                          return (_openBlock(), _createElementBlock("button", {
                                            key: optIndex,
                                            onClick: ($event: any) => (_ctx.selectAnswer(optIndex)),
                                            class: _normalizeClass(["w-full text-left p-4 rounded-xl border-2 transition-all duration-200 cursor-pointer", [
                        _ctx.answers[index] === optIndex
                          ? 'border-mumble-accent bg-mumble-accent/5'
                          : 'border-gray-100 hover:border-mumble-accent/30 hover:bg-gray-50'
                      ]])
                                          }, [
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(option), 1)
                                          ], 10, _hoisted_10))
                                        }), 128))
                                      ])
                                    ])), [
                                      [_vShow, _ctx.currentStep === index]
                                    ])
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_Transition, { name: "fade" }, {
                            default: _withCtx(() => [
                              (_ctx.showResult)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w-16 h-16 bg-mumble-accent/10 rounded-full flex items-center justify-center mx-auto mb-4" }, [
                                      _createElementVNode("svg", {
                                        class: "w-8 h-8 text-mumble-accent",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                      ])
                                    ], -1)),
                                    _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-sm text-gray-600 mb-2" }, "Il piano più adatto a te è", -1)),
                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.recommendedPackage?.displayName), 1),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.packageDescription), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("button", {
                                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
                                        class: "flex-1 px-4 py-3 border border-gray-200 text-gray-600 text-sm font-medium rounded-xl hover:bg-gray-50 transition-colors cursor-pointer"
                                      }, " Ricomincia "),
                                      _createElementVNode("button", {
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmSelection && _ctx.confirmSelection(...args))),
                                        class: "flex-1 px-4 py-3 bg-mumble-accent text-white text-sm font-medium rounded-xl hover:bg-mumble-accent/90 transition-colors cursor-pointer"
                                      }, " Seleziona piano ")
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        (!_ctx.showResult)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_ctx.currentStep > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentStep--)),
                                    class: "px-4 py-2 text-sm text-gray-600 hover:text-mumble-text transition-colors cursor-pointer"
                                  }, " ← Indietro "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_18)),
                              (_ctx.answers[_ctx.currentStep] !== null)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                                    class: "px-6 py-2 bg-mumble-accent text-white text-sm font-medium rounded-lg hover:bg-mumble-accent/90 transition-colors cursor-pointer"
                                  }, _toDisplayString(_ctx.currentStep === _ctx.questions.length - 1 ? 'Vedi risultato' : 'Avanti →'), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}